import { createContext, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { algoliasearch } from 'algoliasearch';
import { useToast } from '@chakra-ui/react';
import { GenError } from '../error_toasts/error';
import axios from 'axios';
const { GoogleGenerativeAI } = require('@google/generative-ai');
export const Home_context = createContext();
export default function Home_context_function({ children }) {
  const [value, setValue] = useState('');
  const [items, setItems] = useState([]);
  const navigate = useNavigate();
  let dummy = [1, 2, 3, 4, 5, 7, 5];
  let id;
  let toast = useToast();
  let dummy_data = {
    header_table_two: [
      {
        'Internal Status': 'Authorized',
        'Reason for change': 'Automatic initialization by Coptis',
        'Updated on': '12/19/2012',
        'Updated by': 'ADM',
      },
    ],
    header_table_one: [
      {
        'RM Code': '0384',
        'Standard price': '10.0000 USD',
        Properties:
          'cell stimulating agent anti-aging anti-wrinkles skin elasticity skin softener emollient',
        'Product type': 'Plant extract Active',
        'Internal Status': 'Authorized',
        'Launch Date': 'Jan 2000',
      },
    ],
    regulation_table_one: [
      {
        '%': '27.200000',
        'EU INCI name': 'Squalane',
        'CAS Number': '111-01-3',
        'EINECS number': '203-825-6',
      },
      {
        '%': '24.000000',
        'EU INCI name': 'Triticum Vulgare Germ Oil',
        'CAS Number': '68917-73-7',
        'EINECS number': '-',
      },
      {
        '%': '24.000000',
        'EU INCI name': 'Helianthus Annuus Seed Oil',
        'CAS Number': '8001-21-6',
        'EINECS number': '232-273-9',
      },
      {
        '%': '24.000000',
        'EU INCI name': 'Hordeum Distichon Extract',
        'CAS Number': '94349-67-4',
        'EINECS number': '305-187-5',
      },
      {
        '%': '0.800000',
        'EU INCI name': 'Phenoxyethanol',
        'CAS Number': '122-99-6',
        'EINECS number': '204-589-7',
      },
    ],
    regulation_table_two: [
      {
        'EU INCI name': 'Squalane',
        'USA INCI name': 'Squalane',
        'Mixed INCI name': 'Squalane',
        'Other INCI name': 'Squalane',
      },
      {
        'EU INCI name': 'Triticum Vulgare Germ Oil',
        'USA INCI name': 'Triticum Vulgare (Wheat) Germ Oil',
        'Mixed INCI name': 'Triticum Vulgare (Wheat) Germ Oil',
        'Other INCI name': 'Triticum Vulgare (Wheat) Germ Oil',
      },
      {
        'EU INCI name': 'Helianthus Annuus Seed Oil',
        'USA INCI name': 'Helianthus Annuus (Sunflower) Seed Oil',
        'Mixed INCI name': 'Helianthus Annuus (Sunflower) Seed Oil',
        'Other INCI name': 'Helianthus Annuus (Sunflower) Seed Oil',
      },
      {
        'EU INCI name': 'Hordeum Distichon Extract',
        'USA INCI name': 'Hordeum Distichon (Barley) Extract',
        'Mixed INCI name': 'Helianthus Annuus (Sunflower) Seed Oil',
        'Other INCI name': 'Helianthus Annuus (Sunflower) Seed Oil',
      },
      {
        'EU INCI name': 'Helianthus Annuus (Sunflower) Seed Oil',
        'USA INCI name': 'Hordeum Distichon (Barley) Extract',
        'Mixed INCI name': 'Hordeum Distichon (Barley) Extract',
        'Other INCI name': 'Hordeum Distichon (Barley) Extract',
      },
      {
        'EU INCI name': 'Phenoxyethanol',
        'USA INCI name': 'Phenoxyethanol',
        'Mixed INCI name': 'Phenoxyethanol',
        'Other INCI name': 'Phenoxyethanol',
      },
    ],
    risk_code_table_one: [
      {
        'Risk code': 'SGH07',
        Pictogram: 'GHS07 (exclamation point)',
      },
    ],
    risk_code_table_two: [
      {
        'Risk code': 'Wng',
        'Legal warning': 'Warning',
      },
    ],
    risk_code_table_three: [
      {
        'Risk code': 'H312',
        'Legal hazard': 'Harmful in contact with skin',
      },
      {
        'Risk code': 'EUH 071',
        'Legal hazard': 'Corrosive to the respiratory tract',
      },
    ],
    risk_code_table_four: [
      {
        'Risk code': 'SGH07',
        'Safety phrases':
          'Wear protective gloves/protective clothing/eye protection/face protection',
      },
      {
        'Risk code': 'P302 + P352',
        'Safety phrases': 'IF ON SKIN: Wash with plenty of water/…',
      },
      {
        'Risk code': 'P312',
        'Safety phrases': 'Call a POISON CENTER/doctor/… if you feel unwell',
      },
      {
        'Risk code': 'P322',
        'Safety phrases': 'Specific measures (see … on this label)',
      },
      {
        'Risk code': 'P363',
        'Safety phrases': 'Wash contaminated clothing before reuse',
      },
      {
        'Risk code': 'SGH07',
        'Safety phrases': 'Dispose of contents/container to …',
      },
    ],
    specification_table_one: [
      {
        'Physico chemical properties': 'Acid value',
        data: 'Max. 10.0',
      },
      {
        'Physico chemical properties': 'Specific gravity( At 20°C )',
        data: '0.800 - 0.900',
      },
    ],
    specification_table_two: [
      {
        'Organoleptic characters': 'Appearance( visual exam )',
        data: 'liquid',
      },
      {
        'Organoleptic characters': 'Color( visual exam )',
        data: 'Slightly milky yellowish oil',
      },
      {
        'Organoleptic characters': 'Odor( olfactive exam )',
        data: 'specific',
      },
    ],
    specification_table_three: [
      {
        Bacteriology: 'Aerobic microorganisms',
        data: 'Max. 500 ppm',
      },
    ],
    tolerance_dummy_data: [
      {
        Tests: 'Skin tolerance',
        result: 'Support : Volunteers Amount : 20%',
        Conclusion: 'non irritant (skin)',
      },
      {
        Tests: 'Ocular tolerance',
        result: 'Support : Volunteers Amount : 20%',
        Conclusion: 'non irritant (eyes)',
      },
      {
        Tests: 'Sensitization',
        result: 'Support : Volunteers Amount : 20%',
        Conclusion: 'nonsensitizing',
      },
    ],
    Substantion_dummy_data: [
      {
        Tests: 'anti-aging',
        data: 'Support : Volunteers',
        Protocol:
          'Granlipid RSC has been shown to stimulate the growth of epidermal cells comparable to the effects seen with retinyl palmitate. Epithelial cell cultures were grown in supplemented MEM. During exponential growth, media was supplemented with various concentration of Granlipid RSC or retinyl palmitate.',
        result:
          'At 0.1% retinyl palmitate increased epithelial growth rates by more than 80% while 0.05% Granlipid RSC increased rates by more than 140%. Using standard skin cell renewal assay (5% dansyl chloride in petrolatum) we observed that 0.5% Granlipid RSC in an inert vehicle increased skin cell renewal rate by 25%. This rate is the optimum amount one would like to see to deliver long-term skin anti-aging effects.',
      },
      {
        Tests: 'Skin elasticity',
        data: 'Support : Volunteers Number : 10',
        Protocol:
          'Ten subjects with dry skin and showing the visible signs of aging, applied 2% Granlipid RSC twice a day for four weeks. At various times through the study test subjects were evaluated for a number of changes in skin condition.',
        result:
          'Skin firmness evaluated by ballistometry, increased by 41% after 4 weeks of treatment. A 17% increase was observed after only 2 weeks. Biopsies were taken at the start and finish of the study. Sections of the stratum corneum were stained with oil red to highlight lipids and the results indicated an 86% increase in skin structural lipid content after the four weeks of treatment. We also observed that dryness on test subjects decreased by more than 30% after 4 weeks, and superficial lines and wrinkles were decreased by more than 25%.',
      },
    ],
    black_list_dummy_data: [
      {
        Brand: 'YVIS PURE SKIN',
        'Max. percentage': '0.000000',
      },
      {
        Brand: 'SILVER COSMETICS',
        'Max. percentage': '100.000000',
      },
      {
        Brand: 'COSMETIC LAB',
        'Max. percentage': '0.000000',
      },
      {
        Brand: 'LALE',
        'Max. percentage': '0.000000',
      },
      {
        Brand: 'MARIE COSMETICS',
        'Max. percentage': '0.000000',
      },

      {
        Brand: 'MODELS',
        'Max. percentage': '0.000000',
      },
      {
        Brand: 'CLFA',

        'Max. percentage': '0.000000',
      },
    ],
    conditions_to_use_dummy_data: [
      {
        Formulation:
          'Cosmetic Use: Granlipid RSC can be used in any emulsion of oil-containing products. Its suggested use level is from 1-5% and it should be added to the oil phase. Temperatures in excess of 80°C should be avoided for any length of time.',
        Incompatibilities: 'Formula dependent.',
        '% utilization': '1 - 5 %',
        Solubility: 'Insoluble',
      },
      {
        Formulation: 'Oil phase',
        Incompatibilities: '',
        '% utilization': '',
        Solubility: '',
      },
    ],
    shelf_life_dummy_data: [
      {
        'Storage conditions':
          'Granlipid RSC should be stored in closed containers. Do Not Exceed Room Temperature (22°C).',
        'Shelf life': '12 Months',
      },
    ],
  };

  // apicall
  async function apicall_getSuggessions(query_text) {
    try {
      const client = algoliasearch(
        'N2CFZ8MXYF',
        '00ced3d8b84d46d2246e51f3f2161501'
      );
      const response = await client.searchSingleIndex({
        indexName: 'naturalhairdatabase',
        searchParams: { query: query_text },
      });
      return response?.hits;
      // console.log(response?.hits)
      // hendleResponce(response);
    } catch (err) {
      toast(GenError('Error while searching'));
    }
    // console.log('response', response);
    
//test



//     let query = `You are tasked with generating a list of comprehensive list of raw materials based on a user's question.
// Your goal is to create a list of raw materials that can be used to get relevant raw materials for building a cosmetic product based on the user's question.

// Here is the user's question:
// <question>
// ${query_text}
// </question>

// To generate list of raw materials, follow these steps:

// 1. Analyze the user's question:
//    - Identify the main topic or subject
//    - Determine the type of information being sought (e.g., definition, comparison, how-to, etc.)
//    - Recognize any specific entities, concepts, or time frames mentioned

// 2. Generate raw materials:
//    - Consider these websites for finding raw materials: https://covalo.com/ingredients, https://www.ulprospector.com/en/asia/PersonalCare/Product?st=1, https://incidecoder.com/, https://www.ewg.org/, https://www.iri-sys.com/, https://thegoodfaceproject.com/brands
//    - Extract name of the raw material, supplier's brand name, its INCI name, its long description in 2-3 lines with its benefits and exact link of the raw material for further information about more properties.
//    - If you find a raw material that is supplied by multiple suppliers, treat them as separate raw materials
//    - Make sure that you give the exact link for the raw material from above websites or drop that raw material
//    - Give atleast 10 raw materials

// 3. Format your output:
//    - Provide your list of related raw materials in JSON format
//    - Use an array of json objects, with each object being a single raw material

// Here's an example of how your output should be formatted:

// <example_question>
// Natural alternatives to retinol with anti-aging properties
// </example_question>

// <example_answer>
// {{
//   "raw_materials": [
//     {{
//       "name": "Bakuchiol",
//       "supplier": "Ashland",
//       "inci_name": "Bakuchiol",
//       "description": "A natural alternative to retinol with anti-aging properties",
//       "link": "https://www.ashland.com/bakuchiol"
//     }},
//     {{
//       "name": "Rosehip Oil",
//       "supplier": "Croda",
//       "inci_name": "Rosa Canina Seed Oil",
//       "description": "A natural oil with anti-aging benefits",
//       "link": "https://www.croda.com/en-gb/rosehip-oil"
//     }},
//     {{
//       "name": "Hyaluronic Acid",
//       "supplier": "Robertet",
//       "inci_name": "Sodium Hyaluronate",
//       "description": "A hydrating ingredient with anti-aging properties",
//       "link": "https://www.robertet.com/en/hyaluronic-acid"
//     }},
//     {{
//       "name": "Niacinamide",
//       "supplier": "BASF",
//       "inci_name": "Niacinamide",
//       "description": "A skin-brightening and anti-aging ingredient",
//       "link": "https://www.basf.com/ "
//     }},
//   ]
// }}
// </example_answer>

// Remember to:
// - Keep the response concise and focused
// - Ensure that each raw material is relevant to the original question or its broader topic
// - Use proper grammar and spelling

// Now, based on the user's question, generate a list of related raw materials in the specified JSON format.
// Provide your output within <answer> tags.`;

//     let genAI = new GoogleGenerativeAI(
//       'AIzaSyDCewLGgPNiIH1Rgz9jtJGxyqWuUm1bYOg'
//     );
//     let model = genAI.getGenerativeModel({ model: 'gemini-1.5-flash' });

//     let prompt = query;

//     let result = await model.generateContent(prompt);
//     // let data=(result.response.text().replace("```json", "").replace('```',''));
//     let data = result.response.text();
//     const cleanString = data.replace(/```json\n|```/g, '').trim();
//     const finalString = cleanString.replace(/<\/?[^>]+(>|$)/g, '').trim();
//     const jsonData = JSON.parse(finalString);
//     let payload = jsonData['raw_materials'];
//     return payload;
  }
  // You are tasked with generating a list of comprehensive list of raw materials based on a user's question.Your goal is to create a list of raw materials that can be used to get relevant raw materials for building a cosmetic product based on the user's question.Here is the user's question:<question>shampoo features a balance of surfactants and conditioning agents for daily use</question>To generate list of raw materials, follow these steps:1. Analyze the user's question:   - Identify the main topic or subject   - Determine the type of information being sought (e.g., definition, comparison, how-to, etc.)   - Recognize any specific entities, concepts, or time frames mentioned2. Generate raw materials:   - Consider these websites for finding raw materials: https://covalo.com/ingredients, https://www.ulprospector.com/en/asia/PersonalCare/Product?st=1, https://incidecoder.com/, https://www.ewg.org/, https://www.iri-sys.com/, https://thegoodfaceproject.com/brands   - Extract name of the raw material, supplier's brand name, its INCI name, its long description in 2-3 lines with its benefits and exact link of the raw material for further information about the raw material.   - If you find a raw material that is supplied by multiple suppliers, treat them as separate raw materials3. Format your output:   - Provide your list of related raw materials in JSON format   - Use an array of json objects, with each object being a single raw materialHere's an example of how your output should be formatted:<example_question>Natural alternatives to retinol with anti-aging properties</example_question><example_answer>{{  "raw_materials": [    {{      "name": "Bakuchiol",      "supplier": "Ashland",      "inci_name": "Bakuchiol",      "description": "A natural alternative to retinol with anti-aging properties",      "link": "https://www.ashland.com/bakuchiol"    }},    {{      "name": "Rosehip Oil",      "supplier": "Croda",      "inci_name": "Rosa Canina Seed Oil",      "description": "A natural oil with anti-aging benefits",      "link": "https://www.croda.com/en-gb/rosehip-oil"    }},    {{      "name": "Hyaluronic Acid",      "supplier": "Robertet",      "inci_name": "Sodium Hyaluronate",      "description": "A hydrating ingredient with anti-aging properties",      "link": "https://www.robertet.com/en/hyaluronic-acid"    }},    {{      "name": "Niacinamide",      "supplier": "BASF",      "inci_name": "Niacinamide",      "description": "A skin-brightening and anti-aging ingredient",      "link": "https://www.basf.com/ "    }},  ]}}</example_answer>Remember to:- Keep the response concise and focused- Ensure that each raw material is relevant to the original question or its broader topic- Use proper grammar and spellingNow, based on the user's question, generate a list of related raw materials in the specified JSON format. Provide your output within <answer> tags.
  function hendleResponce(res) {
    console.log('res array', res);
    let data = [];
    true &&
      res?.hits?.map((el) => {
        console.log(el);
        // data.push(el?.rm_name)
        data.push(el);
      });
    setItems(data || []);
  }

  async function api_call_get_report() {
    return true;
  }

  // end of api_calls

  const [Suggestion_data_state, setSuggestion_data_state] = useState({
    Suggestion_data: [],
    Suggestion_data_state_loading: false,
    Suggestion_data_state_success: false,
    Suggestion_data_state_error: false,
    Suggestion_data_state_message: '',
  });

  function HendlesetSuggestion_data_state_data_state(
    actionType,
    message,
    payload
  ) {
    switch (actionType) {
      case 'SuggestionDataStateLoading': {
        return setSuggestion_data_state({
          Suggestion_data: [],
          Suggestion_data_state_loading: true,
          Suggestion_data_state_success: false,
          Suggestion_data_state_error: false,
          Suggestion_data_state_message: '',
        });
      }
      case 'SuggestionDataStateSuccess': {
        return setSuggestion_data_state({
          Suggestion_data: payload || [],
          Suggestion_data_state_loading: false,
          Suggestion_data_state_success: true,
          Suggestion_data_state_error: false,
          Suggestion_data_state_message: '',
        });
      }
      case 'SuggestionDataStateError': {
        return setSuggestion_data_state({
          Suggestion_data: [],
          Suggestion_data_state_loading: false,
          Suggestion_data_state_success: false,
          Suggestion_data_state_error: true,
          Suggestion_data_state_message: 'Somthing went wrong',
        });
      }
      case 'SuggestionDataStateReset': {
        return setSuggestion_data_state({
          Suggestion_data: [],
          Suggestion_data_state_loading: false,
          Suggestion_data_state_success: false,
          Suggestion_data_state_error: false,
          Suggestion_data_state_message: '',
        });
      }
    }
  }

  // function HendleChange(e) {
  //   clearTimeout(id);
  //   id = setTimeout(async () => {
  //     await HendleApi_call_get_suggesions(e?.query);
  //   }, 4000);
  // }

  function HendleApi_call_get_suggesions(query) {
    HendlesetSuggestion_data_state_data_state(
      'SuggestionDataStateLoading',
      undefined,
      undefined
    );
    apicall_getSuggessions(query)
      .then((res) => hendle_apicall_getSuggessions_success(res))
      .catch((err) => apicall_getSuggessions_error(err));
  }

  function hendle_apicall_getSuggessions_success(res) {
    console.log('hello', res);
    try {
      let is_array = Array.isArray(res);
      if (is_array) {
        HendlesetSuggestion_data_state_data_state(
          'SuggestionDataStateSuccess',
          undefined,
          res
        );
      } else {
        throw 'Somthing went wrong';
      }
    } catch (err) {
      throw 'Somthing went wrong';
    }
  }

  function apicall_getSuggessions_error(err) {
    toast(GenError('Error while searching'));
    HendlesetSuggestion_data_state_data_state(
      'SuggestionDataStateError',
      'Error while searching',
      undefined
    );
  }

  function HendleSelect(thread) {
    console.log(thread);
    setValue(thread);
    Hendlesetreport_data_state('reportDataStateSuccess', undefined, thread);
    navigate(`/home/report_id`);
  }

  // search result dynamic_rout

  const { report_id } = useParams();

  let Dummy_data = {
    chemical_category_en: '',
    chemical_category_lg: '',
    currency: '',
    disposal_en: '',
    disposal_lg: '',
    distributor: '',
    formulation_conditions_en: '',
    formulation_conditions_lg: '',
    ghs_risk_codes: '',
    incompatibilities_en: '',
    incompatibilities_lg: '',
    internal_status: '',
    internal_supplier_code: '',
    lead_time_in_days: '',
    manufacturer: '',
    max_percentage_use: '',
    min_percentage_use: '',
    no_animal_testing: '',
    notes_en: '',
    notes_lg: '',
    objectID: '8de8ac7720cbf_dashboard_generated_id',
    objectivation_tests_notes_en: '',
    objectivation_tests_notes_lg: '',
    origin_details_en: '',
    origin_details_lg: '',
    patents_en: '',
    patents_lg: '',
    presentation_en:
      '2-Propenoic acid, 2-methyl-, 2-(dimethylamino)ethyl ester, polymer with 1-ethenylhexahydro-2H-azepin-2-one and 1-ethenyl-2-pyrrolidinone',
    presentation_lg: '',
    price: '',
    product_type: '',
    properties: 'Film forming, Hair fixing, Skin conditioning',
    regulatory_notes_en: '',
    regulatory_notes_lg: '',
    risk_comments_en: '',
    risk_comments_lg: '',
    rm_code: 1,
    rm_name: 'Vinyl Caprolactam/VP/Dimethylaminoethyl Methacrylate Copolymer',
    rm_name_en: 'advantage™ lc-a polymer',
    shelf_life: '',
    storage_conditions_en: '',
    storage_conditions_lg: '',
    tolerance_tests_notes_en: '',
    tolerance_tests_notes_lg: '',
    warnings: '',
  };

  const [report_data_state, setreport_data_state] = useState({
    report_data: [],
    report_data_state_loading: false,
    report_data_state_success: false,
    report_data_state_error: false,
    report_data_state_message: '',
  });
  console.log(report_data_state);
  function Hendlesetreport_data_state(actionType, message, payload) {
    switch (actionType) {
      case 'reportDataStateLoading': {
        return setreport_data_state({
          report_data: {},
          report_data_state_loading: true,
          report_data_state_success: false,
          report_data_state_error: false,
          report_data_state_message: '',
        });
      }
      case 'reportDataStateSuccess': {
        return setreport_data_state({
          report_data: payload || {},
          report_data_state_loading: false,
          report_data_state_success: true,
          report_data_state_error: false,
          report_data_state_message: '',
        });
      }
      case 'reportDataStateError': {
        return setreport_data_state({
          report_data: {},
          report_data_state_loading: false,
          report_data_state_success: false,
          report_data_state_error: true,
          report_data_state_message: 'Somthing went wrong',
        });
      }
      case 'reportDataStateReset': {
        return setreport_data_state({
          report_data: {},
          report_data_state_loading: false,
          report_data_state_success: false,
          report_data_state_error: false,
          report_data_state_message: '',
        });
      }
    }
  }

  function hendleApicall_get_report(report_id) {
    Hendlesetreport_data_state('reportDataStateLoading');
    api_call_get_report()
      .then((res) => hendleApicall_get_report_success(res))
      .catch((err) => hendleApicall_get_report_error(err));
  }

  function hendleApicall_get_report_success(res) {
    Hendlesetreport_data_state('reportDataStateSuccess', undefined, dummy_data);
  }

  function hendleApicall_get_report_error(err) {
    Hendlesetreport_data_state(
      'reportDataStateError',
      'somthing went wrong',
      {}
    );
  }

  return (
    <Home_context.Provider
      value={{
        report_data_state,
        hendleApicall_get_report,
        value,
        setValue,
        HendleSelect,
        items,
        // HendleChange,
        HendleApi_call_get_suggesions,
        Suggestion_data_state,
      }}
    >
      {children}
    </Home_context.Provider>
  );
}
